export default __webpack_public_path__ + "static/media/armwraps_of_the_forsaken.01f830d3.jpg";